export default "__VITE_ASSET__3OW$qngo__"